var createReactClass = require("create-react-class");
import axios from "axios";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";

const qs = require("qs");
import { logoutUser } from "Redux/actions";

// Keep production API URLs in source while making localhost development safe.
// Axios rewrites them to the local dev-server proxy before any request leaves
// the browser.
axios.interceptors.request.use((config) => {
	if (["localhost", "127.0.0.1"].includes(window.location.hostname) && typeof config.url === "string") {
		config.url = config.url.replace("https://hub.akschap.com/api", "/api");
	}
	return config;
});

function apiCall(path, postData) {
	// console.log("new call");
	return new Promise((resolve, reject) => {
		axios({
			method: "post",
			url: `https://hub.akschap.com/api/${path}?time=${Date.now()}&token=` + localStorage.getItem("user_hash"),
			data: qs.stringify({ data: postData }),
		})
			.then((res) => {
				return resolve(res.data.data);
			})
			.catch(function (error) {
				return reject(error);
			});
	});
}
var API = createReactClass({
	statics: {
		post: function (path, postData) {
			console.log("new call");
			return new Promise((resolve, reject) => {
				axios({
					method: "post",
					url: `https://hub.akschap.com/api/${path}?time=${Date.now()}&token=` + localStorage.getItem("user_hash"),
					data: qs.stringify({ data: postData }),
				})
					.then((res) => {
						return resolve(res.data.data);
					})
					.catch(function (error) {
						return reject(error);
					});
			});
		},
		operator: {
			list: function (postData) {
				return apiCall("operator/list", postData);
			},
		},
		sms: {
			toggleBanned: function (postData) {
				return new Promise((resolve, reject) => {
					axios({
						method: "post",
						url: "https://hub.akschap.com/api/sms/toggle-banned?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
						data: qs.stringify({ data: postData }),
					})
						.then((res) => {
							return resolve(res.data.data);
						})
						.catch(function (error) {
							return reject(error);
						});
				});
			},
			send: function (postData) {
				return new Promise((resolve, reject) => {
					axios({
						method: "post",
						url: "https://hub.akschap.com/api/sms/send?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
						data: qs.stringify({ data: postData }),
					})
						.then((res) => {
							return resolve(res.data.data);
						})
						.catch(function (error) {
							return reject(error);
						});
				});
			},
			updateItem: function (postData) {
				return new Promise((resolve, reject) => {
					axios({
						method: "post",
						url: "https://hub.akschap.com/api/sms/update-item?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
						data: qs.stringify({ data: postData }),
					})
						.then((res) => {
							return resolve(res.data.data);
						})
						.catch(function (error) {
							return reject(error);
						});
				});
			},
			getList: function (postData) {
				return new Promise((resolve, reject) => {
					axios({
						method: "post",
						url: "https://hub.akschap.com/api/sms/get-list?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
						data: qs.stringify({ data: postData }),
					})
						.then((res) => {
							return resolve(res.data.data);
						})
						.catch(function (error) {
							return reject(error);
						});
				});
			},
			batch: {
				add: function (postData) {
					return new Promise((resolve, reject) => {
						axios({
							method: "post",
							url: "https://hub.akschap.com/api/sms/batch/add?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
							data: qs.stringify({ data: postData }),
						})
							.then((res) => {
								return resolve(res.data.data);
							})
							.catch(function (error) {
								return reject(error);
							});
					});
				},
				edit: function (postData) {
					return new Promise((resolve, reject) => {
						axios({
							method: "post",
							url: "https://hub.akschap.com/api/sms/batch/edit?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
							data: qs.stringify({ data: postData }),
						})
							.then((res) => {
								return resolve(res.data.data);
							})
							.catch(function (error) {
								return reject(error);
							});
					});
				},
				archive: function (postData) {
					return new Promise((resolve, reject) => {
						axios({
							method: "post",
							url: "https://hub.akschap.com/api/sms/batch/archive?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
							data: qs.stringify({ data: postData }),
						})
							.then((res) => {
								return resolve(res.data.data);
							})
							.catch(function (error) {
								return reject(error);
							});
					});
				},
				list: function (postData) {
					return new Promise((resolve, reject) => {
						axios({
							method: "post",
							url: "https://hub.akschap.com/api/sms/batch/list?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
							data: qs.stringify({ data: postData }),
						})
							.then((res) => {
								return resolve(res.data.data);
							})
							.catch(function (error) {
								return reject(error);
							});
					});
				},
				sendTest: function (postData) {
					return new Promise((resolve, reject) => {
						axios({
							method: "post",
							url: "https://hub.akschap.com/api/sms/batch/send-test?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
							data: qs.stringify({ data: postData }),
						})
							.then((res) => {
								return resolve(res.data.data);
							})
							.catch(function (error) {
								return reject(error);
							});
					});
				},
				send: function (postData) {
					return new Promise((resolve, reject) => {
						axios({
							method: "post",
							url: "https://hub.akschap.com/api/sms/batch/send?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
							data: qs.stringify({ data: postData }),
						})
							.then((res) => {
								return resolve(res.data.data);
							})
							.catch(function (error) {
								return reject(error);
							});
					});
				},
			},
		},
		crm: {
			customer: {
				add: function (postData) {
					return new Promise((resolve, reject) => {
						axios({
							method: "post",
							url: "https://hub.akschap.com/api/crm/customer/add?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
							data: qs.stringify({ data: postData }),
						})
							.then((res) => {
								return resolve(res.data.data);
							})
							.catch(function (error) {
								return reject(error);
							});
					});
				},
				list: function (postData) {
					return new Promise((resolve, reject) => {
						axios({
							method: "post",
							url: "https://hub.akschap.com/api/crm/customer/list?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
							data: qs.stringify({ data: postData }),
						})
							.then((res) => {
								return resolve(res.data.data);
							})
							.catch(function (error) {
								return reject(error);
							});
					});
				},

				dashboard: function (postData) {
					return new Promise((resolve, reject) => {
						axios({
							method: "post",
							url: "https://hub.akschap.com/api/crm/customer/dashboard?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
							data: qs.stringify({ data: postData }),
						})
							.then((res) => {
								return resolve(res.data.data);
							})
							.catch(function (error) {
								return reject(error);
							});
					});
				},
				customerTagName: function (postData) {
					return new Promise((resolve, reject) => {
						axios({
							method: "post",
							url: "https://hub.akschap.com/api/crm/customer/customer-tag-name?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
							data: qs.stringify({ data: postData }),
						})
							.then((res) => {
								return resolve(res.data.data);
							})
							.catch(function (error) {
								return reject(error);
							});
					});
				},
			},
			lead: {
				add: function (postData) {
					return new Promise((resolve, reject) => {
						axios({
							method: "post",
							url: "https://hub.akschap.com/api/crm/lead/add?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
							data: qs.stringify({ data: postData }),
						})
							.then((res) => {
								return resolve(res.data.data);
							})
							.catch(function (error) {
								return reject(error);
							});
					});
				},
				listPulseTags: function () {
					return new Promise((resolve, reject) => {
						axios({
							method: "post",
							url: "https://hub.akschap.com/api/crm/lead/listpulsetag?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
						})
							.then((res) => {
								return resolve(res.data.data);
							})
							.catch(function (error) {
								return reject(error);
							});
					});
				},
				dashboard: function () {
					return new Promise((resolve, reject) => {
						axios({
							method: "post",
							url: "https://hub.akschap.com/api/crm/lead/dashboard?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
						})
							.then((res) => {
								return resolve(res.data.data);
							})
							.catch(function (error) {
								return reject(error);
							});
					});
				},
				list: function (postData) {
					return new Promise((resolve, reject) => {
						axios({
							method: "post",
							url: "https://hub.akschap.com/api/crm/lead/list?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
							data: qs.stringify({ data: postData }),
						})
							.then((res) => {
								return resolve(res.data.data);
							})
							.catch(function (error) {
								return reject(error);
							});
					});
				},
				listmulti: function (postData) {
					return new Promise((resolve, reject) => {
						axios({
							method: "post",
							url: "https://hub.akschap.com/api/crm/lead/list-multi?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
							data: qs.stringify({ data: postData }),
						})
							.then((res) => {
								return resolve(res.data.data);
							})
							.catch(function (error) {
								return reject(error);
							});
					});
				},
				listpending: function (postData) {
					return new Promise((resolve, reject) => {
						axios({
							method: "post",
							url: "https://hub.akschap.com/api/crm/lead/list-pending?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
							data: qs.stringify({ data: postData }),
						})
							.then((res) => {
								return resolve(res.data.data);
							})
							.catch(function (error) {
								return reject(error);
							});
					});
				},
				view: function (postData) {
					return new Promise((resolve, reject) => {
						axios({
							method: "post",
							url: "https://hub.akschap.com/api/crm/lead/view?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
							data: qs.stringify({ data: postData }),
						})
							.then((res) => {
								return resolve(res.data.data);
							})
							.catch(function (error) {
								return reject(error);
							});
					});
				},
			},
		},
		customer: {
			smsLatest: function (postData) {
				return new Promise((resolve, reject) => {
					axios({
						method: "post",
						url: "https://hub.akschap.com/api/customer/sms-latest?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
						data: qs.stringify({ data: postData }),
					})
						.then((res) => {
							return resolve(res.data.data);
						})
						.catch(function (error) {
							return reject(error);
						});
				});
			},
			view: function (postData) {
				return new Promise((resolve, reject) => {
					axios({
						method: "post",
						url: "https://hub.akschap.com/api/customer/view?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
						data: qs.stringify({ data: postData }),
					})
						.then((res) => {
							return resolve(res.data.data);
						})
						.catch(function (error) {
							return reject(error);
						});
				});
			},
		},
		system: {
			getNotifications: function () {
				return new Promise((resolve, reject) => {
					axios({
						method: "post",
						url: "https://hub.akschap.com/api/system/get-notifications?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
					})
						.then((res) => {
							return resolve(res.data.data);
						})
						.catch(function (error) {
							return reject(error);
						});
				});
			},
			listSystemLog: function (postData) {
				return new Promise((resolve, reject) => {
					axios({
						method: "post",
						url: "https://hub.akschap.com/api/system/list-system-log?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
						data: qs.stringify({ data: postData }),
					})
						.then((res) => {
							return resolve(res.data.data);
						})
						.catch(function (error) {
							return reject(error);
						});
				});
			},
			saveItemWeight: function (postData) {
				return new Promise((resolve, reject) => {
					axios({
						method: "post",
						url: "https://hub.akschap.com/api/system/product-tree-update-item?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
						data: qs.stringify({ data: postData }),
					})
						.then((res) => {
							return resolve(res.data.data);
						})
						.catch(function (error) {
							return reject(error);
						});
				});
			},
			saveProductsTree: function (postData) {
				return new Promise((resolve, reject) => {
					axios({
						method: "post",
						url: "https://hub.akschap.com/api/system/product-tree-get-update-list?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
						data: qs.stringify({ data: postData }),
					})
						.then((res) => {
							return resolve(res.data.data);
						})
						.catch(function (error) {
							return reject(error);
						});
				});
			},
			productPriceUpdateItem: function (postData) {
				return new Promise((resolve, reject) => {
					axios({
						method: "post",
						url: "https://hub.akschap.com/api/system/product-price-update-item?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
						data: qs.stringify({ data: postData }),
					})
						.then((res) => {
							return resolve(res.data.data);
						})
						.catch(function (error) {
							return reject(error);
						});
				});
			},
			productPriceGetList: function (postData) {
				return new Promise((resolve, reject) => {
					axios({
						method: "post",
						url: "https://hub.akschap.com/api/system/product-price-get-list?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
						data: qs.stringify({ data: postData }),
					})
						.then((res) => {
							return resolve(res.data.data);
						})
						.catch(function (error) {
							return reject(error);
						});
				});
			},
		},
		address: {
			print: function (PostData) {
				return new Promise((resolve, reject) => {
					axios({
						method: "post",
						url: "https://hub.akschap.com/api/address/print?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
						data: qs.stringify({ data: PostData }),
					})
						.then((res) => {
							return resolve(res.data.data);
						})
						.catch(function (error) {
							return reject(error);
						});
				});
			},
		},
		order: {
			print: function (PostData) {
				return new Promise((resolve, reject) => {
					axios({
						method: "post",
						url: "https://hub.akschap.com/api/order/print?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
						data: qs.stringify({ data: PostData }),
					})
						.then((res) => {
							return resolve(res.data.data);
						})
						.catch(function (error) {
							return reject(error);
						});
				});
			},
			view: function (PostData) {
				return new Promise((resolve, reject) => {
					axios({
						method: "post",
						url: "https://hub.akschap.com/api/order/view?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
						data: qs.stringify({ data: PostData }),
					})
						.then((res) => {
							return resolve(res.data.data);
						})
						.catch(function (error) {
							return reject(error);
						});
				});
			},
			cancle: function (PostData) {
				return new Promise((resolve, reject) => {
					axios({
						method: "post",
						url: "https://hub.akschap.com/api/order/record-cancle?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
						data: qs.stringify({ data: PostData }),
					})
						.then((res) => {
							return resolve(res.data.data);
						})
						.catch(function (error) {
							return reject(error);
						});
				});
			},
			lists: {
				payment: {
					get: function (PostData) {
						return new Promise((resolve, reject) => {
							axios({
								method: "post",
								url: "https://hub.akschap.com/api/order/queue-payment?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
								data: qs.stringify({ data: PostData }),
							})
								.then((res) => {
									return resolve(res.data.data);
								})
								.catch(function (error) {
									return reject(error);
								});
						});
					},
					record: function (PostData) {
						return new Promise((resolve, reject) => {
							axios({
								method: "post",
								url: "https://hub.akschap.com/api/order/record-payment?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
								data: qs.stringify({ data: PostData }),
							})
								.then((res) => {
									return resolve(res.data.data);
								})
								.catch(function (error) {
									return reject(error);
								});
						});
					},
				},
				process: {
					get: function () {
						return new Promise((resolve, reject) => {
							axios
								.get("https://hub.akschap.com/api/order/queue-process?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"))
								.then((res) => {
									return resolve(res.data.data);
								})
								.catch(function (error) {
									return reject(error);
								});
						});
					},
					record: function (PostData) {
						return new Promise((resolve, reject) => {
							axios({
								method: "post",
								url: "https://hub.akschap.com/api/order/record-process?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
								data: qs.stringify({ data: PostData }),
							})
								.then((res) => {
									return resolve(res.data.data);
								})
								.catch(function (error) {
									return reject(error);
								});
						});
					},
				},
			},
			archive: function (searchData) {
				return new Promise((resolve, reject) => {
					axios({
						method: "post",
						url: "https://hub.akschap.com/api/order/archive?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
						data: qs.stringify({ data: searchData }),
					})
						.then((res) => {
							return resolve(res.data.data);
						})
						.catch(function (error) {
							return reject(error);
						});
				});
			},
			new: {
				productsTree: function () {
					return new Promise((resolve, reject) => {
						axios
							.get("https://hub.akschap.com/api/order/products/tree?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"))
							.then((res) => {
								return resolve(res.data.data);
							})
							.catch(function (error) {
								return reject(error);
							});
					});
				},
				productsData: function () {
					return new Promise((resolve, reject) => {
						axios
							.get("https://hub.akschap.com/api/order/products/data?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"))
							.then((res) => {
								return resolve(res.data.data);
							})
							.catch(function (error) {
								return reject(error);
							});
					});
				},
				lookupCustomer: function (PostData) {
					return new Promise((resolve, reject) => {
						axios({
							method: "post",
							url: "https://hub.akschap.com/api/customer/lookup?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
							data: qs.stringify({ data: PostData }),
						})
							.then((res) => {
								return resolve(res.data.data);
							})
							.catch(function (error) {
								return reject(error);
							});
					});
				},
				place: function (orderData) {
					return new Promise((resolve, reject) => {
						axios({
							method: "post",
							url: "https://hub.akschap.com/api/order/new?time=" + Date.now() + "&token=" + localStorage.getItem("user_hash"),
							data: qs.stringify({ data: orderData }),
						})
							.then((res) => {
								return resolve(res.data.data);
							})
							.catch(function (error) {
								return reject(error);
							});
					});
				},
			},
		},
	},

	render: function () {
		return;
	},
});

export default connect()(API);
